import { useSelector } from 'react-redux';
import { ExclamationCircleIcon } from '@interstate/components/Icons/ExclamationCircleIcon';
import * as programsSelectors from '@makemydeal/dr-dash-store/selectors/programsSelectors';
import { Box } from '@interstate/components/Box';
import { filterUniqueMessages } from '../utils/mapUtils';
import { GuidelineAlerts } from './GuidelineAlerts';
import { useSlideoutDrawer } from '@makemydeal/dr-dash-components';
import { Typography } from '@interstate/components/Typography';

export const ProgramsAndIncentivesHeader = () => {
    const allProgramMessages = useSelector(programsSelectors.getAllMessages);
    const guideLineAlerts = filterUniqueMessages(allProgramMessages);
    const guideLineAlertsCount = guideLineAlerts.length;

    const { showContent } = useSlideoutDrawer();

    const handleClickShowAlerts = () => {
        showContent(GuidelineAlerts, {
            header: 'Lender Guideline Alerts'
        });
    };

    return guideLineAlertsCount > 0 ? (
        <Box
            data-testid="guideline-alerts-link"
            onClick={handleClickShowAlerts}
            display="flex"
            gap="0.5rem"
            justifyContent="flex-end"
            alignItems="center"
            className="text-primary"
        >
            <ExclamationCircleIcon />
            <Typography variant="anchor-inline-sm" sx={{ color: 'inherit' }}>
                Lender Guideline Alerts ({guideLineAlertsCount})
            </Typography>
        </Box>
    ) : null;
};
